// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NewCoreIconProps } from '@atlaskit/icon';
import SuccessIcon from '@atlaskit/icon/core/check-circle';
import CommentIcon from '@atlaskit/icon/core/comment';
import DownloadIcon from '@atlaskit/icon/core/download';
import FeedbackIcon from '@atlaskit/icon/core/feedback';
import ErrorIcon from '@atlaskit/icon/core/status-error';
import InfoIcon from '@atlaskit/icon/core/status-information';
import WarningIcon from '@atlaskit/icon/core/status-warning';
import { token } from '@atlaskit/tokens';

export type FlagMapping = Record<string, Flag>;

export type FlagMappingIcon =
	| typeof SuccessIcon
	| typeof ErrorIcon
	| typeof WarningIcon
	| typeof InfoIcon
	| typeof CommentIcon
	| typeof DownloadIcon
	| typeof FeedbackIcon;

export type Flag = {
	component: FlagMappingIcon;
	label: string;
	color: string;
};

const flagMapping: {
	success: {
		component: {
			(props: NewCoreIconProps): JSX.Element;
			displayName: string;
		};
		label: string;
		color: 'var(--ds-icon-success)';
	};
	error: {
		component: {
			(props: NewCoreIconProps): JSX.Element;
			displayName: string;
		};
		label: string;
		color: 'var(--ds-icon-danger)';
	};
	info: {
		component: {
			(props: NewCoreIconProps): JSX.Element;
			displayName: string;
		};
		label: string;
		color: 'var(--ds-icon-information)';
	};
	warning: {
		component: {
			(props: NewCoreIconProps): JSX.Element;
			displayName: string;
		};
		label: string;
		color: 'var(--ds-icon-warning)';
	};
	smallInfo: {
		component: {
			(props: NewCoreIconProps): JSX.Element;
			displayName: string;
		};
		label: string;
		color: 'var(--ds-icon-discovery)';
	};
	comment: {
		component: {
			(props: NewCoreIconProps): JSX.Element;
			displayName: string;
		};
		label: string;
		color: 'var(--ds-icon)';
	};
	download: {
		component: {
			(props: NewCoreIconProps): JSX.Element;
			displayName: string;
		};
		label: string;
		color: 'var(--ds-icon)';
	};
	feedback: {
		component: {
			(props: NewCoreIconProps): JSX.Element;
			displayName: string;
		};
		label: string;
		color: 'var(--ds-icon)';
	};
} = {
	success: {
		component: SuccessIcon,
		label: 'success',
		color: token('color.icon.success'),
	},
	error: {
		component: ErrorIcon,
		label: 'error',
		color: token('color.icon.danger'),
	},
	info: {
		component: InfoIcon,
		label: 'info',
		color: token('color.icon.information'),
	},
	warning: {
		component: WarningIcon,
		label: 'warning',
		color: token('color.icon.warning'),
	},
	smallInfo: {
		component: InfoIcon,
		label: 'info',
		color: token('color.icon.discovery'),
	},
	comment: {
		component: CommentIcon,
		label: 'comment',
		color: token('color.icon'),
	},
	download: {
		component: DownloadIcon,
		label: 'download',
		color: token('color.icon'),
	},
	feedback: {
		component: FeedbackIcon,
		label: 'comment',
		color: token('color.icon'),
	},
};

export type FlagIcons = keyof typeof flagMapping;

export default flagMapping;
